import type {
  ProductColor,
  ProductColorBubble,
  ProductColorBubble_GradientColor,
  ProductColorBubble_SimpleColors,
  ProductColorBubble_SimpleColors_Color,
} from "../../aysa_api/models/product_color.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseProductColor = (): ProductColor => {
  return {
    id: 0,
    name: "",
    slug: "",
  };
};

export const decodeProductColor = (
  reader: Reader,
  length: number
): ProductColor => {
  const end = reader.pos + length;
  const message = createBaseProductColor();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.name = reader.string();

        break;
      case 3:
        message.slug = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductColor = (
  writer: Writer,
  message: ProductColor
): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(18).string(message.name);
  writer.uint32(26).string(message.slug);

  return writer;
};

export const createBaseProductColorBubble = (): ProductColorBubble => {
  return {
    productId: 0,
  };
};

export const decodeProductColorBubble = (
  reader: Reader,
  length: number
): ProductColorBubble => {
  const end = reader.pos + length;
  const message = createBaseProductColorBubble();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 3:
        message.productId = (reader.int64() as Long).toNumber();

        break;
      case 1:
        message.color = {
          $case: "gradient",
          gradient: decodeProductColorBubble_GradientColor(
            reader,
            reader.uint32()
          ),
        };

        break;
      case 2:
        message.color = {
          $case: "simple",
          simple: decodeProductColorBubble_SimpleColors(
            reader,
            reader.uint32()
          ),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductColorBubble = (
  writer: Writer,
  message: ProductColorBubble
): Writer => {
  writer.uint32(24).int64(message.productId);
  if (message.color !== undefined) {
    switch (message.color.$case) {
      case "gradient":
        encodeProductColorBubble_GradientColor(
          writer.uint32(10).fork(),
          message.color.gradient
        ).ldelim();

        break;
      case "simple":
        encodeProductColorBubble_SimpleColors(
          writer.uint32(18).fork(),
          message.color.simple
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseProductColorBubble_GradientColor =
  (): ProductColorBubble_GradientColor => {
    return {
      hexCodes: [],
    };
  };

export const decodeProductColorBubble_GradientColor = (
  reader: Reader,
  length: number
): ProductColorBubble_GradientColor => {
  const end = reader.pos + length;
  const message = createBaseProductColorBubble_GradientColor();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.hexCodes.push(reader.string());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductColorBubble_GradientColor = (
  writer: Writer,
  message: ProductColorBubble_GradientColor
): Writer => {
  for (const value of message.hexCodes) {
    writer.uint32(10).string(value);
  }

  return writer;
};

export const createBaseProductColorBubble_SimpleColors =
  (): ProductColorBubble_SimpleColors => {
    return {
      colors: [],
    };
  };

export const decodeProductColorBubble_SimpleColors = (
  reader: Reader,
  length: number
): ProductColorBubble_SimpleColors => {
  const end = reader.pos + length;
  const message = createBaseProductColorBubble_SimpleColors();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 2:
        message.colors.push(
          decodeProductColorBubble_SimpleColors_Color(reader, reader.uint32())
        );

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductColorBubble_SimpleColors = (
  writer: Writer,
  message: ProductColorBubble_SimpleColors
): Writer => {
  for (const value of message.colors) {
    encodeProductColorBubble_SimpleColors_Color(
      writer.uint32(18).fork(),
      value
    ).ldelim();
  }

  return writer;
};

export const createBaseProductColorBubble_SimpleColors_Color =
  (): ProductColorBubble_SimpleColors_Color => {
    return {
      hexCode: "",
      isLightColor: false,
    };
  };

export const decodeProductColorBubble_SimpleColors_Color = (
  reader: Reader,
  length: number
): ProductColorBubble_SimpleColors_Color => {
  const end = reader.pos + length;
  const message = createBaseProductColorBubble_SimpleColors_Color();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.hexCode = reader.string();

        break;
      case 2:
        message.isLightColor = reader.bool();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductColorBubble_SimpleColors_Color = (
  writer: Writer,
  message: ProductColorBubble_SimpleColors_Color
): Writer => {
  writer.uint32(10).string(message.hexCode);
  writer.uint32(16).bool(message.isLightColor);

  return writer;
};
